import React from 'react';
import { NextPage } from 'next';
import Layout from '../../../components/layout';
import AccountLayout from '../../../components/account-layout';
import useCustomer from '../../../hooks/use-customer';
import SoftwareOrdersByUser from '../../../components/@software/software-orders-by-user';
import Loading from '../../../components/loading';
import AccountPrompt from '../../../components/account-prompt';

const AccountSoftwareRefundPage: NextPage = () => {
  const customer = useCustomer();

  if (typeof window === 'undefined') {
    return null;
  }

  return (
    <Layout title="My Software Orders">
      <AccountLayout
        title="My Software Orders"
        breadcrumb={{ url: '/account', text: 'Back to My Account' }}
        columns={false}
        subtitle="View details related to your software orders."
      >
        <div className="content">
          <p>
            Software order refunds are handled on a case by case basis. Refund
            requests must be submitted within 14 days of the order.
          </p>
          <p>
            To request a refund, click on the "Request Refund" button for the
            corresponding order. If there is no button, the order is no longer
            eligible for a refund.
          </p>
          {customer ? (
            <React.Fragment>
              {customer.customer!.guest ? (
                <AccountPrompt
                  signup={false}
                  text="Please sign in to access your software orders."
                />
              ) : (
                <SoftwareOrdersByUser customer={customer.customer!} />
              )}
            </React.Fragment>
          ) : (
            <Loading message="Loading account information..." />
          )}
        </div>
      </AccountLayout>
    </Layout>
  );
};

export default AccountSoftwareRefundPage;
